/**
 * Villager-owned equipment assets (UI mock).
 * Linked to People Master via peopleId.
 * Fields align with M_Vehicle Equipment / mobile asset registration.
 */

function vehicleDocs(assetId, { pending = false } = {}) {
  const sides = [
    {
      id: `${assetId}-front`,
      group: 'sides',
      label: 'Front',
      fileName: `${assetId.toLowerCase()}_front.jpg`,
      kind: 'image',
    },
    {
      id: `${assetId}-rear`,
      group: 'sides',
      label: 'Rear',
      fileName: `${assetId.toLowerCase()}_rear.jpg`,
      kind: 'image',
    },
    {
      id: `${assetId}-left`,
      group: 'sides',
      label: 'Left',
      fileName: `${assetId.toLowerCase()}_left.jpg`,
      kind: 'image',
    },
    {
      id: `${assetId}-right`,
      group: 'sides',
      label: 'Right',
      fileName: `${assetId.toLowerCase()}_right.jpg`,
      kind: 'image',
    },
  ];
  const compliance = [
    {
      id: `${assetId}-puc`,
      group: 'compliance',
      label: 'PUC certificate',
      fileName: `${assetId.toLowerCase()}_puc.pdf`,
      kind: 'pdf',
    },
    {
      id: `${assetId}-ins`,
      group: 'compliance',
      label: 'Insurance policy',
      fileName: `${assetId.toLowerCase()}_insurance.pdf`,
      kind: 'pdf',
    },
    {
      id: `${assetId}-fit`,
      group: 'compliance',
      label: 'Fitness certificate',
      fileName: `${assetId.toLowerCase()}_fitness.pdf`,
      kind: 'pdf',
    },
  ];
  // Pending assets may only have side photos uploaded
  if (pending) return sides;
  return [...sides, ...compliance];
}

export const villagerAssetSeed = [
  {
    assetId: 'AST-001',
    peopleId: 'P-001',
    equipmentType: 'Tractor',
    equipmentDescription: 'TRACTOR',
    remarks: '',
    vehicleClass: 'LMV',
    manufacturer: 'Mahindra',
    model: '575 DI',
    variant: '4WD',
    regNo: 'GJ12 AB 1234',
    chassisNumber: 'MBH575DI0001234',
    engineNumber: 'MH575E98765',
    dateOfReg: '2019-03-15',
    regValidUpto: '2034-03-14',
    nameAsPerRc: 'Ramesh Karsan Patel',
    sonOfWifeOf: 'Karsan Patel',
    color: 'Red',
    fuel: 'Diesel',
    pucDate: '2025-01-10',
    pucValidUpto: '2026-01-09',
    insuranceIssueDate: '2025-02-01',
    insuranceValidUpto: '2026-01-31',
    taxValidUpto: '2026-03-31',
    fitnessValidUpto: '2027-03-14',
    status: 'Verified',
    documents: vehicleDocs('AST-001'),
  },
  {
    assetId: 'AST-002',
    peopleId: 'P-001',
    equipmentType: 'Trailer',
    equipmentDescription: 'TRAILER',
    remarks: 'Used for material haulage',
    vehicleClass: 'HMV',
    manufacturer: 'Local',
    model: 'Trolley',
    variant: '10 ton',
    regNo: 'GJ12 CD 5678',
    chassisNumber: 'LOCTRL0005678',
    engineNumber: '—',
    dateOfReg: '2020-06-20',
    regValidUpto: '2035-06-19',
    nameAsPerRc: 'Ramesh Karsan Patel',
    sonOfWifeOf: 'Karsan Patel',
    color: 'Yellow',
    fuel: 'Diesel',
    pucDate: '2025-01-10',
    pucValidUpto: '2026-01-09',
    insuranceIssueDate: '2025-02-01',
    insuranceValidUpto: '2026-01-31',
    taxValidUpto: '2026-03-31',
    fitnessValidUpto: '2027-06-19',
    status: 'Verified',
    documents: vehicleDocs('AST-002'),
  },
  {
    assetId: 'AST-003',
    peopleId: 'P-002',
    equipmentType: 'Water Tanker',
    equipmentDescription: 'WATER TANKER',
    remarks: '',
    vehicleClass: 'HMV',
    manufacturer: 'Tata',
    model: '1613',
    variant: '9000 L',
    regNo: 'GJ12 EF 9012',
    chassisNumber: 'MAT16130009012',
    engineNumber: 'TT1613E44521',
    dateOfReg: '2021-08-05',
    regValidUpto: '2036-08-04',
    nameAsPerRc: 'Meena Bhima Jadeja',
    sonOfWifeOf: 'Bhima Jadeja',
    color: 'White',
    fuel: 'Diesel',
    pucDate: '2024-11-01',
    pucValidUpto: '2025-10-31',
    insuranceIssueDate: '2024-12-01',
    insuranceValidUpto: '2025-11-30',
    taxValidUpto: '2025-12-31',
    fitnessValidUpto: '2026-08-04',
    status: 'Pending',
    documents: vehicleDocs('AST-003', { pending: true }),
  },
  {
    assetId: 'AST-004',
    peopleId: 'P-003',
    equipmentType: 'Backhoe Loader',
    equipmentDescription: 'BACKHOE LOADER',
    remarks: '',
    vehicleClass: 'Construction Equipment',
    manufacturer: 'JCB',
    model: '3DX',
    variant: 'Super',
    regNo: 'GJ12 GH 3456',
    chassisNumber: 'JCB3DX0003456',
    engineNumber: 'JCB3DXE77881',
    dateOfReg: '2018-11-22',
    regValidUpto: '2033-11-21',
    nameAsPerRc: 'Suresh Laxman Gadhvi',
    sonOfWifeOf: 'Laxman Gadhvi',
    color: 'Yellow',
    fuel: 'Diesel',
    pucDate: '2025-03-01',
    pucValidUpto: '2026-02-28',
    insuranceIssueDate: '2025-03-15',
    insuranceValidUpto: '2026-03-14',
    taxValidUpto: '2026-03-31',
    fitnessValidUpto: '2026-11-21',
    status: 'Verified',
    documents: vehicleDocs('AST-004'),
  },
  {
    assetId: 'AST-005',
    peopleId: 'P-003',
    equipmentType: 'Excavator',
    equipmentDescription: 'EXCAVATOR',
    remarks: '',
    vehicleClass: 'Construction Equipment',
    manufacturer: 'Hitachi',
    model: 'ZX210',
    variant: 'LC',
    regNo: 'GJ12 IJ 7890',
    chassisNumber: 'HITZX210007890',
    engineNumber: 'HITZXE11223',
    dateOfReg: '2022-01-18',
    regValidUpto: '2037-01-17',
    nameAsPerRc: 'Suresh Laxman Gadhvi',
    sonOfWifeOf: 'Laxman Gadhvi',
    color: 'Orange',
    fuel: 'Diesel',
    pucDate: '2025-04-01',
    pucValidUpto: '2026-03-31',
    insuranceIssueDate: '2025-04-10',
    insuranceValidUpto: '2026-04-09',
    taxValidUpto: '2026-03-31',
    fitnessValidUpto: '2027-01-17',
    status: 'Verified',
    documents: vehicleDocs('AST-005'),
  },
];

export function findAssetsByPeopleId(peopleId) {
  return villagerAssetSeed.filter((a) => a.peopleId === peopleId);
}

export function findAssetById(assetId) {
  return villagerAssetSeed.find((a) => a.assetId === assetId) || null;
}

/** Vehicle age in whole years from date of registration. */
export function vehicleAgeFromReg(dateOfReg) {
  if (!dateOfReg) return null;
  const d = new Date(dateOfReg);
  if (Number.isNaN(d.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age -= 1;
  return age >= 0 ? age : null;
}
